/* eslint-disable no-undef */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import Iframe from './components/IframeDialog.js'
import Toast from './components/ToastDialog.js'
import EventBus from './services/event_bus'

Vue.config.productionTip = false
Vue.use(Iframe)
Vue.use(Toast)

let onmessage = (event) => {
  // console.log('onmesssage')
  // console.log(event)
  let messageData = event.data
  if (messageData['command']) {
    EventBus.$emit(messageData.command, messageData.content)
  }
}
if (typeof window.addEventListener !== 'undefined') {
  window.addEventListener('message', onmessage, false)
} else if (typeof window.attachEvent !== 'undefined') {
  window.attachEvent('onmessage', onmessage)
}

let loadVueJs = function () {
  console.log('build loaded')
  let loadingElement = document.getElementById('page-loading')
  loadingElement.parentNode.removeChild(loadingElement)
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
  })
}

if (window.frames.length !== parent.frames.length) {
  // 在iframe中
  if (!window.WebViewJavascriptBridge && window.parent.WebViewJavascriptBridge) {
    window.WebViewJavascriptBridge = window.parent.WebViewJavascriptBridge
  }
  loadVueJs()
} else {
  let isLetsgoiOSBrowser = (/LetsGo/i).test(navigator.userAgent)
  let isLetsgoAndroidBrowser = (/XmonsterAndroid/i).test(navigator.userAgent)
  if (isLetsgoAndroidBrowser) {
    if (window.WebViewJavascriptBridge) {
      WebViewJavascriptBridge.init(function (message, responseCallback) {
      })
      loadVueJs()
    } else {
      document.addEventListener('WebViewJavascriptBridgeReady', function () {
        WebViewJavascriptBridge.init(function (message, responseCallback) {
        })
        loadVueJs()
      }, false)
    }
  } else if (isLetsgoiOSBrowser) {
    if (window.WebViewJavascriptBridge) {
      loadVueJs()
    }
    if (window.WVJBCallbacks) {
      window.WVJBCallbacks.push(loadVueJs)
    }
    window.WVJBCallbacks = [loadVueJs]
    var WVJBIframe = document.createElement('iframe')
    WVJBIframe.style.display = 'none'
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
    document.documentElement.appendChild(WVJBIframe)
    setTimeout(function () {
      document.documentElement.removeChild(WVJBIframe)
    }, 0)
  } else {
    window.WebViewJavascriptBridge = undefined
    loadVueJs()
  }
}



// WEBPACK FOOTER //
// ./src/main.js